import { Component, Show } from "solid-js";

type RawHtmlProps = { value: string }
export const RawHtml : Component<RawHtmlProps> = ({ value }) => <Show when={value}><div innerHTML={value}></div></Show>;